import styled, { css } from 'styled-components';
import colors from 'Styles/colors';
import { FaChevronDown as ChevronDown } from 'react-icons/fa';

const ColorRole = {
  admin: colors.warmPurple,
  pentester: '#EA3158',
  client: '#0082ED',
  system: '#8da6be',
  user: '#f59220',
  asset_owner: colors.grey2
};

export const resolveRoleKey = (role) => {
  const r = String(role || '').toLowerCase();

  if (r.includes('asset')) return 'asset_owner';
  if (r.includes('admin')) return 'admin';
  if (r.includes('pentest')) return 'pentester';
  if (r.includes('client')) return 'client';
  if (r.includes('system')) return 'system';
  if (r.includes('user')) return 'user';

  return 'user';
};

export const Wrapper = styled.div`
  margin-bottom: ${({ $embedded }) => ($embedded ? '0' : '24px')};
  border-radius: 4px;
  overflow: hidden;
  background-color: ${({ theme }) => theme?.backgrounds?.scheduleWrapper || theme?.backgrounds?.panel || 'transparent'};
  box-shadow: 0 2px 50px 0 rgba(0, 0, 0, 0.1);

  ${({ $embedded }) =>
    $embedded &&
    css`
      height: 100%;
      display: flex;
      flex-direction: column;
      position: relative;

      /* blur/shadow difuminado abajo como en el diseño */
      &::after {
        content: '';
        position: absolute;
        left: 0;
        right: 0;
        bottom: -1px;
        height: 18px;
        pointer-events: none;
        opacity: 0.35;
        filter: blur(6px);
        background: linear-gradient(
          to bottom,
          rgba(0,0,0,0),
          rgba(0,0,0,0.35)
        );
      }
    `}
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: 14px 18px;
  cursor: pointer;
  user-select: none;

  border-bottom: 1px solid ${({ theme }) => theme.borders.dashboardRow};
`;

export const Title = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.text.dashboardTitle};
`;

export const Chevron = styled(ChevronDown)`
  width: 14px;
  height: 14px;
  color: ${({ theme }) => theme.text.dashboardLightText};
  transition: transform 0.2s ease;

  transform: rotate(90deg);

  ${({ $open }) =>
    $open &&
    css`
      transform: rotate(0deg);
    `}
`;

export const Content = styled.div`
  padding: 16px 18px 18px 18px;

  ${({ $embedded }) =>
    $embedded &&
    css`
      flex: 1;
      min-height: 0;
      overflow: auto;
    `}
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

export const Col = styled.div``;

export const Row = styled.div`
  display: flex;
  align-items: baseline;
  gap: 10px;
  margin-bottom: 10px;
`;

export const RowTop = styled(Row)`
  align-items: flex-start;
`;

export const Key = styled.div`
  min-width: 110px;
  color: ${({ theme }) => theme.text.dashboardDarkText};
  font-size: 12px;
  font-weight: 400;
`;

export const Value = styled.div`
  color: ${({ theme }) => theme.text.dashboardLightText};
  font-weight: 400;
  min-width: 0;
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ValuePrimary = styled(Value)`
  font-size: 12px;
`;

export const Divider = styled.div`
  height: 1px;
  margin: 14px 0 16px 0;
  background: ${({ theme }) => theme.borders.dashboardRow};
`;

export const UsersList = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
`;

export const UserRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

export const Username = styled.div`
  color: ${({ theme }) => theme.text.dashboardLightText};
  font-size: 12px;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Role = styled.div`
  ${({ $role }) => {
    const key = resolveRoleKey($role);
    const color = ColorRole[key] || colors.grey5;

    return css`
      color: ${color};
      font-size: 12px;
      white-space: nowrap;
    `;
  }}
`;
